import { Roles } from "@outschool/auth-shared";
import { Child, User } from "@outschool/gql-backend-generated";

import { LearnersRow } from "../../shared/generated/database";
import { FullCurrentUserFragmentFragment } from "../../shared/generated/graphql";
import { preferredAges } from "../../shared/User";

export function isOrganizationAdmin(
  user: FullCurrentUserFragmentFragment
): boolean {
  return Boolean(user?.organizationAdmin);
}

export function isOrganizationAdminWhoCanEnroll(
  user: FullCurrentUserFragmentFragment //This is not necessary currentUser
): boolean {
  return (
    user?.organizationAdmin &&
    user?.roles?.includes(Roles.CanOrganizationEnroll)
  );
}

type DefaultSortOrder = "upcoming" | "relevance";

export function searchDefaults(
  user?: Pick<User, "admin_for_organization_uid"> & {
    children: Array<Pick<Child, "age">>;
  },
  learners?: LearnersRow[]
) {
  let filters: {
    age?: string;
    order?: DefaultSortOrder;
  } = {};
  if (!user?.admin_for_organization_uid) {
    let ages = preferredAges(user, learners);
    ages.filter(age => age < 19);
    if (ages.length) {
      filters.age = ages.join(",");
    }
  }

  return filters;
}
